import MaterialList from "../../components/Material/List";

const MaterialPage = () => {
  return (
    <MaterialList/>
  )
}

export default MaterialPage